import { render } from "./Header.html?vue&type=template&id=2b1de755&scoped=true&ts=true&external"
import script from "./Header.ts?vue&type=script&lang=ts&external"
export * from "./Header.ts?vue&type=script&lang=ts&external"

import "./Header.scss?vue&type=style&index=0&id=2b1de755&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1de755"]])

export default __exports__